import { createI18n } from 'vue-i18n'
import fr from './locales/fr'
import de from './locales/de'
import en from './locales/en'
import none from './locales/none'

/**
 * Deep merge objects while preserving sub-objects
 */
export const deepMerge = (target: any, source: any) => {
  const output = { ...target }
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, { [key]: source[key] })
        else output[key] = deepMerge(target[key], source[key])
      } else {
        Object.assign(output, { [key]: source[key] })
      }
    })
  }
  return output
}

function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

export default createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr: fr,
    de: de,
    en: en
  }
})